export default __webpack_public_path__ + "static/media/Central-de-Odontologia-de-Gravataí.ae3ba782.png";